import React from "react";
import { Combobox } from "react-widgets";

function SearchAndSelect({ label, options, setSelected, ...rest }) {
  return (
    <div>
      {label ? <div className="h5">{label}</div> : null}
      <div className="mb-4">
        <Combobox
          data={options}
          dataKey="_id"
          textField="name"
          filter="contains"
          onSelect={setSelected}
          {...rest}
        />
      </div>
    </div>
  );
}

export default SearchAndSelect;
